import React from 'react';

import Box from '@mui/material/Box';

import Panel from '@ts-core/components/Panel/Panel';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';

import AccountCircle from '@mui/icons-material/AccountCircle';

interface BaseTimelineCardProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

const BaseTimelineCard = (props: BaseTimelineCardProps) => {
  const { children, title, subtitle = '' } = props;
  return (
    <Panel>
      <Box mb={2}>
        <Grid container alignItems="flex-start" justifyContent="flex-start" spacing={1}>
          <Grid item>
            <AccountCircle style={{ fontSize: 44 }} />
          </Grid>
          <Grid item>
            <Typography variant="subtitle2" color="secondary">
              {title}
            </Typography>
            <Typography variant="caption">{subtitle}</Typography>
          </Grid>
        </Grid>
        <Divider />
      </Box>
      <Box>{children}</Box>
    </Panel>
  );
};

export default BaseTimelineCard;
